/* eslint-disable no-console */
import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { EastSlider } from '../EastSlider/EastSlider';
import Swiper from 'swiper';

@Component
export class LightBox extends ThemeComponent {
    @Ref() close!: HTMLElement;
    @Ref() lightboxSlider!: EastSlider;
    @Ref() openSidebar!: HTMLElement;
    @Ref() closeSidebar!: HTMLElement;
    @Ref() sidebar!: HTMLElement;

    @Prop id!: string;

    private productContainers: NodeListOf<HTMLElement> = this.querySelectorAll('.lightbox__products-container');

    init() {
        const triggerElements: NodeListOf<Element> = document.body.querySelectorAll(`[data-trigger="${this.id}"]`);

        // eslint-disable-next-line no-var
        for (var trigger of triggerElements) {
            trigger.addEventListener("click", (e) => {
                this.openLightbox(e.currentTarget as HTMLElement);
            });
        }

        this.closeButton();
        this.handleSlideChange();
        this.handleSidebarEvents();
    }

    openLightbox(trigger: HTMLElement) {
        const triggerId = trigger.dataset.trigger;
        const slideIndex = Number(trigger.dataset.slideIndex);

        // Ensure swiper index exists
        if (typeof this.lightboxSlider.swiper === 'undefined') {
            return;
        }

        console.log(slideIndex);
        document.body.classList.add('modal-open');

        // show correct products
        for (const container of this.productContainers) {
            const containerIndex = Number(container.dataset.slideIndex);
            container.classList.toggle('active', containerIndex == slideIndex);
        }

        this.lightboxSlider.swiper.enable();
        this.lightboxSlider.swiper.attachEvents();
        this.lightboxSlider.swiper.update();

        this.lightboxSlider.swiper.slideTo(slideIndex, 0, false);

        if(triggerId == this.id) {
            this.style.display = "flex";
        }
    }

    closeButton() {
        this.close.addEventListener('click', () => {
            this.style.display = "none";
            document.body.classList.remove('modal-open');

            // update swiper
            if (this.lightboxSlider.swiper) {
                this.lightboxSlider.swiper.disable();
            }
        });
    }

    handleSlideChange() {
        this.lightboxSlider.swiper?.on('slideChangeTransitionStart', (swiper: Swiper) => {
            for (const container of this.productContainers) {
                const slideIndex = Number(container.dataset.slideIndex);
                container.classList.toggle('active', slideIndex === swiper.realIndex + 1);
            }
        });
    }

    handleSidebarEvents() {
        this.openSidebar.addEventListener('click', () => {
            this.openSidebar.classList.add('active');
            this.sidebar.classList.add('active');
        });

        this.closeSidebar.addEventListener('click', () => {
            this.sidebar.classList.remove('active');
            setTimeout(() => {
                this.openSidebar.classList.remove('active');
            }, 400);
            document.body.classList.remove('modal-open');
        });
    }
}
